import { LoginRequest } from '../models/login-request.model';
import { UserAdminLoginDto } from '../models/user-admin-login.dto';

export class LoginRequestMapper {
  static toUserAdminLoginDto(request: LoginRequest): UserAdminLoginDto {
    return {
      id: 0,
      name: null,
      lastName: null,
      motherMaidenName: null,
      email: request.email,
      password: request.password,
      lastPassword: null,
      photoUrl: null,
      userAdminTypeId: 0,
      userAdminType: null,
      createdAt: null,
      updatedAt: null,
      isEnabled: null,
      pushNotificationToken: request.pushNotificationToken ?? null,
    };
  }
}
